const axios = require("axios").default;

const URL = `${process.env.REACT_APP_API_URL}/rdetail`;

export const getAll = (payload) => {
  return axios.get(URL, {
    params: payload,
  });
};
